export default __webpack_public_path__ + "static/media/coinx.88c9f802.png";